import React from 'react';
import {
  bool,
  func,
  string,
} from 'prop-types';
import {dissoc} from 'ramda';
import Radio from 'muicss/lib/react/radio';
import styles from './RadioButton.css';
import classNames from 'classnames';

const RadioButton = (props) => {
  const iconStyles = classNames({
    [styles.icon]: true,
    'fa': true,
    'fa-dot-circle-o': props.checked,
    'fa-circle-o': !props.checked,
  });

  return (
    <label className={classNames(styles.container, props.className)}
      disabled={props.disabled}>
      <i className={iconStyles}/>
      <Radio
        className={styles.muiRadio}
        {...dissoc('className', props)} />
    </label>
  );
};

RadioButton.propTypes = {
  label: string,
  autoFocus: bool,
  checked: bool,
  className: string,
  defaultChecked: bool,
  defaultValue: bool,
  disabled: bool,
  form: string,
  name: string,
  required: string,
  value: string,
  onChange: func,
};

export default RadioButton;
